import { useLocalDebouncedFn } from 'hooks/useLocalDebouncedFn'
import { useQueryClient } from 'react-query'
import { useItemsRealtime } from 'screens/Finder/hooks/useRealtime'
import { calendarKeys } from './calendarKeys'
import { CalendarFilters } from 'screens/Calendar/types'
import { filesKeys } from '../files/filesKeys'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const useCalendarRealtime = (filters: CalendarFilters) => {
  const queryClient = useQueryClient()
  const currentWorkspaceId = useCurrentWorkspaceId()

  const refreshAfterExternalChange = useLocalDebouncedFn(
    () => {
      queryClient.invalidateQueries(calendarKeys.filters(filters))
      queryClient.invalidateQueries(filesKeys.partialCalendar(currentWorkspaceId))
    },
    300,
    {},
    [queryClient],
  )

  useItemsRealtime({
    folderId: filters.projectKeys?.[0],
    onItemsMessage: refreshAfterExternalChange,
  })
}
